export const firstString = (...args) => {
  for (const arg of args) {
    if (arg && String(arg).trim().length) {
      return arg
    }
  }

  return 'N/A'
}

export const debugOnlyCall = {
  apply: (target, thisArg, argumentsList) => {
    if (process.env.NODE_ENV === 'development') {
      target(...argumentsList)
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/conditional.js